import { render, staticRenderFns } from "./validate-shipment-confirmation.vue?vue&type=template&id=3a3010b0&"
import script from "./validate-shipment-confirmation.vue?vue&type=script&lang=js&"
export * from "./validate-shipment-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports